// export function appendFineAnt() {
// 	const script = document.createElement("script");
// 	script.src = "https://www.fireant.vn/Scripts/web/widgets.js";
// 	script.defer = true;
// 	script.onload = () => {
// 		new FireAnt.QuoteWidget({
// 			container_id: "fan-quote-373",
// 			symbols: "IJC",
// 			locale: "vi",
// 			price_line_color: "#71BDDF",
// 			grid_color: "#999999",
// 			label_color: "#999999",
// 			width: "100%",
// 			height: "200px",
// 		});
// 	};
// 	document.querySelector(".iframe-fineant").appendChild(script);
// 	console.log("🟢 Fineant is added!");
// }

/*==================== Header ====================*/

import { buttonToTop, detectCloseElement } from "./helper";

/**
 * @param header
 */
function isMobileOrTablet() {
	const userAgent = navigator.userAgent.toLowerCase();
	const mobileKeywords = ["mobile", "android", "iphone", "ipad", "ipod"];
	const tabletKeywords = ["tablet", "ipad"];

	for (const keyword of mobileKeywords) {
		if (userAgent.includes(keyword)) {
			return true;
		}
	}

	for (const keyword of tabletKeywords) {
		if (userAgent.includes(keyword)) {
			return true;
		}
	}
}

export const header = {
	scrollActive: function () {
		let height = $("header").height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
			$("header").removeClass("slideUp");
		} else {
			$("header").removeClass("active");
			$("header").removeClass("slideUp");
		}
	},
	hambuger: function () {
		$(".header-hambuger").on("click", function () {
			$("body").toggleClass("isOpenMenu");
		});
		function closeMenu() {
			$("body").removeClass("isOpenMenu");
		}
		detectCloseElement(".header-menu", "header-hambuger", closeMenu);
	},
	clickMenu: function () {
		if (isMobileOrTablet()) {
			let clickCounts = {};
			$(".header-menu a").on("click", function (e) {
				const elementId = $(this).attr("href");
				if (!$(this).next("ul").length) {
					return true;
				}
				// Reset click count for all elements except the current one
				Object.keys(clickCounts).forEach((key) => {
					if (key !== elementId) {
						clickCounts[key] = 0;
					}
				});
				if (!clickCounts[elementId]) {
					clickCounts[elementId] = 1;
				} else {
					clickCounts[elementId]++;
				}
				if (clickCounts[elementId] > 1) {
					return true;
				}
				return false;
			});
		}
	},
	scrollToTabActive: function () {
		const $container = $(".wrap-tab-list");
		const $activeTab = $container.find(".active");
		if ($activeTab.length) {
			const containerLeft = $container.offset().left;
			const activeTabLeft = $activeTab.offset().left;
			const scrollLeft = activeTabLeft - containerLeft - $container.width() / 2 + $activeTab.width() / 2;
			$container.animate(
				{
					scrollLeft: scrollLeft,
				},
				300
			);
		}
	},
	init: function () {
		buttonToTop();
		header.scrollActive();
		header.clickMenu();
		header.hambuger();
		header.scrollToTabActive();
	},
};
document.addEventListener(
	"scroll",
	function (e) {
		header.scrollActive();
	},
	true
);
